import { ShareButton } from '../ShareButton';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'ShareButton',
  category: '🔘 Botões',
  description: 'Botão social com ícone e cor do canal (WhatsApp, Telegram, etc)',
  usedIn: ['ReferralDashboard'],
  example: () => (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      <ShareButton icon="📱" label="WhatsApp" color="#25D366" onClick={() => alert('WhatsApp')} />
      <ShareButton icon="✈️" label="Telegram" color="#0088cc" onClick={() => alert('Telegram')} />
      <ShareButton icon="📧" label="Email" color="#2F6BFF" onClick={() => alert('Email')} />
      <ShareButton icon="🐦" label="Twitter" color="#1DA1F2" onClick={() => alert('Twitter')} />
    </div>
  ),
};
